<template>
  <div id="portfoliomedia">
    <div class="container admin-wrap mt-5">
      <div class="row header mb-3">
        <div class="col-lg-12">
          <h3 class="text-center">PORTFOLIO MEDIA</h3>
          <span></span>
        </div>
      </div>
      <div class="pb-5 row">
        <div class="col-lg-12">
          <div class="row portfolio-media_list">
            <div v-if="mediaList.length < 1 && !isLoad" class="empty-list_image">
              <strong>{{ startupText }}</strong>
              <img src="../assets/notfound.png" />
            </div>

            <div class="lds-ellipsis" style="margin: 0 auto" v-if="isLoad">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>

            <div class="col-lg-12 mt-5" v-if="mediaList.length > 1">
              <!--<b-carousel style="text-shadow: 1px 1px 2px #333;"-->
              <!--controls-->
              <!--indicators-->
              <!--:interval="0">-->
              <!--<div v-for="media in mediaList">-->
              <!--<b-carousel-slide>-->
              <!--<img slot="img" class="card-img-top d-block img-fluid "-->
              <!--:src="convertToFile(media)"-->
              <!--/>-->
              <!--</b-carousel-slide>-->

              <!--</div>-->
              <!--</b-carousel>-->

              <el-carousel :interval="4000" type="card" height="200px">
                <el-carousel-item v-for="media in mediaList" :key="media.ID">
                  <img v-if="isImage(media)" :src="convertToFile(media)" />

                  <video controls v-else-if="isVideo(media)" style="max-height: 100%; max-width: 100%">
                    <source :src="`data:` + media.PostItemFileType + `;base64, ${media.PostItemFileLow}`" :type="media.PostItemFileType" />
                  </video>

                  <audio controls v-else-if="isAudio(media)" style="max-width: 100%">
                    <source :src="`data:` + media.PostItemFileType + `;base64, ${media.PostItemFileLow}`" :type="media.PostItemFileType" />
                  </audio>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-else class="col-lg-12 mt-5">
              <div v-for="media in mediaList">
                <img :src="convertToFile(media)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="portfolioMedia_bg" v-if="mediaList.length > 0">
        <img src="../assets/media_bg.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'

export default {
  name: 'PortfolioMedia',
  data() {
    return {
      startupText: 'No Media Found...',
      mediaList: [],
      isLoad: false,
    }
  },
  async created() {
    if (this.$route.query.id === '' || this.$route.query.id === null || this.$route.query.id === undefined) {
      this.mediaList = []
    } else {
      this.getMedia(decodeURI(this.$route.query.id))
    }
  },
  methods: {
    async getMedia(inputString) {
      this.isLoad = true
      try {
        const response = await DataSource.shared.getPostFileWithoutTokenCheckByEncryptedPostID(inputString)
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error Get Media - Please try again later...',
            })
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'No Record',
              message: 'No Media Found...',
            })
          } else {
            this.isLoad = false
            this.mediaList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    convertToFile(file) {
      return 'data:' + file.PostItemFileType + ';base64,' + file.PostItemFile
    },

    isImage(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isImage = false

      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.BMP':
        case '.GIF':
        case '.JPEG':
          isImage = true
          break
        default:
          isImage = false
          break
      }

      return isImage
    },

    isVideo(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isVideo = false

      switch (ext) {
        case '.MP4':
          isVideo = true
          break
        default:
          isVideo = false
          break
      }

      return isVideo
    },

    isAudio(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isAudio = false

      switch (ext) {
        case '.MP3':
        case '.AAC':
        case '.WAV':
        case '.M4A':
          isAudio = true
          break
        default:
          isAudio = false
          break
      }

      return isAudio
    },
  },
}
</script>

<style scoped></style>
